// Recovered compiled webpack factory 76066. Edit this function expression; run npm run build.
(t, e, i) => {
  i.d(e, { x: () => r });
  var n = i(33182),
    s = i(93709);
  function r(t, e, i) {
    let r = t.style,
      o = e?.style,
      a = {};
    if (!r) return a;
    for (let e in r)
      ((0, n.S)(r[e]) ||
        (o && (0, n.S)(o[e])) ||
        (0, s.zK)(e, t) ||
        i?.getValue(e)?.liveStyle !== void 0) &&
        (a[e] = r[e]);
    return a;
  }
}
